module.exports = __webpack_public_path__ + "img/MoDesk3.589ce50d.png";